import React from 'react';
import { Button } from "../components/ui/button";

interface HeaderButtonProps {
  children: React.ReactNode;
  className?: string;
  variant: any;
  size: any;
  asChild?: boolean;
  onClick?: () => void;
}

const HeaderButton: React.FC<HeaderButtonProps> = ({ className, ...props }) => (
  <Button className={className ?? ""} {...props} />
);

interface CardHeaderProps {
  icon: string | React.ReactNode;
  title: string;
  subtitle: string;
  iconColor?: string;
  primaryAction?: string;
  secondaryAction?: string;
  tertiaryAction?: string;
  quaternaryAction?: string;
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
  onTertiaryAction?: () => void;
  onQuaternaryAction?: () => void;
}

const CardHeader: React.FC<CardHeaderProps> = ({ 
  icon, 
  title, 
  subtitle, 
  iconColor = "bg-sync-blue",
  primaryAction,
  secondaryAction,
  tertiaryAction,
  quaternaryAction,
  onPrimaryAction,
  onSecondaryAction,
  onTertiaryAction,
  onQuaternaryAction
}) => {
  return (
    <div className="px-8 pt-6 pb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {/* Icône */}
          <div className={`w-16 h-16 ${iconColor} rounded-xl flex items-center justify-center shadow-sm overflow-hidden`}>
            {typeof icon === 'string' ? (
              <img 
                src={icon} 
                alt={title}
                className="w-full h-full object-contain p-1"
              />
            ) : (
              <div className="text-text-inverse text-xl">
                {icon}
              </div>
            )}
          </div>
          
          {/* Titre et sous-titre */}
          <div className="flex flex-col ml-4">
            <h1 className="text-2xl font-semibold text-[#2D3748] mb-0 leading-tight tracking-tight">
              {title}
            </h1>
            <p className="text-base text-[#718096] leading-relaxed tracking-tight whitespace-pre-wrap">
              {subtitle}
            </p>
          </div>
        </div>

        {/* Actions */}
        {(primaryAction || secondaryAction || tertiaryAction || quaternaryAction) && (
          <div className="flex items-center gap-3">
            {quaternaryAction && (
              <HeaderButton variant="outline" size="lg" onClick={onQuaternaryAction}>
                {quaternaryAction}
              </HeaderButton>
            )}
            {tertiaryAction && (
              <HeaderButton variant="outline" size="lg" onClick={onTertiaryAction}>
                {tertiaryAction}
              </HeaderButton>
            )}
            {secondaryAction && (
              <HeaderButton variant="outline" size="lg" onClick={onSecondaryAction}>
                {secondaryAction}
              </HeaderButton>
            )}
            {primaryAction && (
              <HeaderButton 
                variant="default" 
                size="lg" 
                onClick={onPrimaryAction}
                className="bg-[#FF9F68] text-white hover:bg-[#FF9F68]/90"
              >
                {primaryAction}
              </HeaderButton>
            )}
          </div>
        )}
      </div>
      
      {/* Trait de séparation - déplacé après les tabs dans ConfigPage */}
    </div>
  );
};

export default CardHeader;